import { Component, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {NavigationComponent} from './layout/navigation/navigation.component';
import {HeaderComponent} from './layout/header/header.component';
import {ProgressBarComponent} from './components/progress-bar/progress-bar.component';
import {Layout, RouteService} from './services/route.service';
import {AnalyticsService} from './services/analytics.service';
import {HotkeysService} from './services/hotkeys.service';
import {LoggerService} from './services/logger.service';
import {OverlayscrollbarsModule} from 'overlayscrollbars-ngx';
import {WaIntersectionObserver} from '@ng-web-apis/intersection-observer';
import {RouterOutlet} from '@angular/router';
import {osDark} from './layout/overlay-scroll-options';
import {ActionBarComponent} from './layout/action-bar/action-bar.component';
import {ZendeskChatComponent} from './components/zendesk-chat/zendesk-chat.component';
import config from 'devextreme/core/config';
import { licenseKey } from '../devextreme-license';


@Component({
    selector: 'app-root',
	standalone: true,
	imports: [
		CommonModule, NavigationComponent, HeaderComponent, ProgressBarComponent,
		OverlayscrollbarsModule, WaIntersectionObserver, RouterOutlet, ActionBarComponent, ZendeskChatComponent
	],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
	private routeService = inject(RouteService);
	private analytics = inject(AnalyticsService);
	private hotkeys = inject(HotkeysService);
	private logger = inject(LoggerService);

	title = 'Financial Intelligence Tool';

	isLoading = this.routeService.isLoading;

	isSpaciousLayout = false;

	isMenuVisible = false;
	isContentScrolled = false;

	constructor() {
		this.analytics.init();
		config({ licenseKey });
		this.routeService.layout.subscribe(layout => this.isSpaciousLayout = layout === Layout.spacious);
	}

	protected readonly osDark = osDark;
}
